import { render, staticRenderFns } from "./HoldingFutures.vue?vue&type=template&id=1d414993&scoped=true&"
import script from "./HoldingFutures.vue?vue&type=script&lang=js&"
export * from "./HoldingFutures.vue?vue&type=script&lang=js&"
import style0 from "./HoldingFutures.vue?vue&type=style&index=0&id=1d414993&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d414993",
  null
  
)

export default component.exports